module.exports = __webpack_public_path__ + "static/media/clock-face.57a0f2f1.svg";